import { OrganizationDTO } from './organization.types';

export type CommissionStatus = 'pending_invoice' | 'invoiced' | 'paid';
export type CommissionParty = 'referrer' | 'company_organization';
export type CommissionPayeeType =
  | 'expert_individual'
  | 'expert_organization'
  | 'company';

export interface CommissionDTO {
  id: string;
  company_id: string;
  referral_id: string;
  referral_code: string;
  sequence_number: number;
  commission_type: string;
  commission_party: CommissionParty;
  invoice_for: string;
  payee_type: CommissionPayeeType;
  payee_expert_id?: string;
  payee_organization_id?: string;
  payee_name: string;
  invoice_recipient_type?: CommissionPayeeType;
  invoice_recipient_expert_id?: string;
  invoice_recipient_organization_id?: string;
  invoice_recipient_name?: string;
  company_organization_id?: string;
  company_organization_name?: string;
  rate_bps: number;
  amount_minor: number;
  deal_value_minor?: number;
  job_duration_months?: number;
  currency: string;
  calculated_at: string | Date;
  invoice_eligible_at: string | Date;
  invoice_status: CommissionStatus;
  invoice_id?: string;
  invoice_number?: string;
  invoiced_at?: string | Date;
  paid_at?: string | Date;
  created_at: string | Date;
  updated_at: string | Date;
}

export interface CommissionListResponseDTO {
  items: CommissionDTO[];
  total: number;
  page: number;
  limit: number;
}

export interface CommissionSearchDTO {
  referral_id?: string;
  invoice_status?: CommissionStatus;
  commission_type?: string;
  payee_type?: string;
  payee_organization_id?: string;
  invoice_recipient_organization_id?: string;
  commission_party?: CommissionParty;
  date_from?: Date | string;
  date_to?: Date | string;
  page?: number;
  limit?: number;
  sort_by?: string;
  sort_direction?: 'asc' | 'desc';
}

export interface CommissionListFilters {
  invoiceStatus: CommissionStatus | 'all';
  commissionType: string | 'all';
  referrerType: CommissionPayeeType | 'all';
  payeeOrganization: Partial<OrganizationDTO> | null;
  recipientOrganization: Partial<OrganizationDTO> | null;
}

export const defaultCommissionListFilters = (): CommissionListFilters => ({
  invoiceStatus: 'all',
  commissionType: 'all',
  referrerType: 'all',
  payeeOrganization: null,
  recipientOrganization: null,
});

export const cloneCommissionListFilters = (
  filters: CommissionListFilters
): CommissionListFilters => ({
  invoiceStatus: filters.invoiceStatus ?? 'all',
  commissionType: filters.commissionType ?? 'all',
  referrerType: filters.referrerType ?? 'all',
  payeeOrganization: filters.payeeOrganization ?? null,
  recipientOrganization: filters.recipientOrganization ?? null,
});

export const COMMISSION_TYPE_LABELS: Record<string, string> = {
  initial_time_based: 'Initial',
  retainer_completion: 'Retainer',
};

export const COMMISSION_INVOICE_STATUS_LABELS: Record<
  CommissionStatus,
  string
> = {
  pending_invoice: 'Pending Invoice',
  invoiced: 'Invoiced',
  paid: 'Paid',
};

export const COMMISSION_PARTY_LABELS: Record<CommissionParty, string> = {
  referrer: 'Referrer',
  company_organization: 'SNDBX',
};
